export { default } from './SloganText';
